import { Feature } from "ol";
import { Coordinate } from "ol/coordinate";
import { Geometry, GeometryCollection, LineString, MultiLineString, Polygon } from "ol/geom";
import generateSymbol from "../common/symbols";
import ParserBase, { TokenType } from "./parserBase";

export default class LineParser extends ParserBase {

    parseFeature():Feature {
        let token = this.skipUntil(TokenType.FEATURE);
        if (token === TokenType.EOF)
            return undefined;
        
        let objectNameParts = this._lines[this._cursor].replace("&O", "").trim().split(" ");
        let attributes: {[key:string]:any} = {
            layer: objectNameParts[0],
            objectNumber: objectNameParts[1] || undefined
        };
        let continueParsing:boolean = true;
        let geometries:Geometry[] = [];
        while (continueParsing) {
            token = this.readLine();
            switch (token) {
                case TokenType.LINE:
                    let l = this.parseSingleGeometry();
                    this._cursor--;
                    if (l) {
                        geometries.push(l.g);
                        if (objectNameParts[0] === "HROBY" && l.pt.some(t => t == "K=6")) {
                            attributes["isProjected"] = true;
                        }
                    }
                break;
                case TokenType.ATTRIBUTE:
                    let [k, v] = this.parseAttribute();
                    attributes[k] = v;
                break;
                case TokenType.FEATURE:
                case TokenType.EOF:
                    continueParsing = false;
                break;
            }
        }
        if (geometries.length === 0) {
            return undefined;
        } else {
            return new Feature({
                geometry: (geometries.length === 1) ? geometries[0] : new GeometryCollection(geometries),
                ...attributes
            });
        }
    }

    parseGeometry():Geometry {
        let parseResult = this.parseSingleGeometry();
        return parseResult.g;
    }

    private parseSingleGeometry() : {g:Geometry, pt: string[]} {
        let token = this.skipUntil(TokenType.LINE);
        if (token === TokenType.EOF)
            return undefined;

        let segments : Coordinate[][] = [];
        let penTokens : string[] = [];
        let currentCoordinates : Coordinate[] = [];
        let shouldParseNextLine:boolean = true;

        while (shouldParseNextLine) {
            let currentLine = this._lines[this._cursor].replace("&L", "").trim();
            let tokens = currentLine.split(" ");
            if (currentCoordinates.length > 0 && tokens[0] === "P") {
                segments.push(currentCoordinates);
                currentCoordinates = [];
            }
            penTokens.push(...tokens.filter(t => t.startsWith("K=")));
            if (tokens[0] === "P" && tokens.some(t => t.startsWith("S="))) {
                let point = [-tokens[1]+this._offset.y, -tokens[2]+this._offset.x];
                let symbolToken = tokens.find(t => t.startsWith("S="));
                let scaleToken = tokens.find(t => t.startsWith("M="));
                let angleToken = tokens.find(t => t.startsWith("U="));
                let symbolCoords = generateSymbol(point, symbolToken, angleToken, scaleToken);
                if (symbolCoords && symbolCoords.length > 0)
                    segments.push(...symbolCoords);
            } else if (tokens[0] === "L" || tokens[0] === "P") {
                let coords = [-tokens[1]+this._offset.y, -tokens[2]+this._offset.x];
                currentCoordinates.push(coords);
            }
            this._cursor++;
            if (this._cursor > this._lines.length || this._lines[this._cursor].trim().startsWith("&")) {
                shouldParseNextLine = false;
            }
        }
        if (currentCoordinates.length > 1)
            segments.push(currentCoordinates);

        if (segments.length === 0)
            return undefined;
        if (segments.length === 1) {
            return {g: new LineString(segments[0], "XY"), pt: penTokens};
        } else  {
            return {g: new MultiLineString(segments), pt: penTokens};
        }
    }
}